import { combineReducers } from 'redux';
import data from './data';
import list from './list';
import meta from './meta'

export default (resource) => combineReducers({
  data: data(resource),
  list: list(resource),
  meta: meta(resource),
});



// WEBPACK FOOTER //
// ./src/reducers/resource/index.js